// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2m8iD","header":"ClearentDisclaimer_header__1pX_i","inner":"ClearentDisclaimer_inner__3kkt8"};